import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

// Bee Icon Component
const BeeIcon = ({ className = "w-6 h-6" }) => (
  <img 
    src="/images/logos/honeycomb-logo.png" 
    alt="Queen B" 
    className={className}
    style={{ objectFit: 'contain' }}
  />
);

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-zinc-800" data-testid="main-footer">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <BeeIcon className="w-7 h-7" />
              <div>
                <span className="font-bold text-xl text-white block">Queen B Logistics</span>
                <span className="text-[#D4AF37] text-xs tracking-wider uppercase">Premium Freight Operations</span>
              </div>
            </Link>
            <p className="text-zinc-500 mb-4 text-sm leading-relaxed">
              Limited-access freight operations firm specializing in revenue optimization, 
              compliance oversight, and operational infrastructure.
            </p>
            <div className="space-y-2">
              <a href="mailto:dispatch@queenblogistics.com" className="flex items-center gap-2 text-zinc-400 hover:text-[#D4AF37] text-sm transition-colors">
                <Mail className="w-4 h-4" />
                dispatch@queenblogistics.com
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-bold text-white mb-4 uppercase tracking-wide text-sm">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/build" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Build (New Authority)</Link></li>
              <li><Link to="/protect" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Protect (Compliance)</Link></li>
              <li><Link to="/grow" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Grow (Dispatch)</Link></li>
              <li><Link to="/carrier-chronicles" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Chronicles</Link></li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="font-bold text-white mb-4 uppercase tracking-wide text-sm">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/mission" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Mission</Link></li>
              <li><Link to="/vision" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Vision</Link></li>
              <li><Link to="/core-values" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Core Values</Link></li>
              <li><Link to="/locations" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Locations</Link></li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h4 className="font-bold text-white mb-4 uppercase tracking-wide text-sm">Support</h4>
            <ul className="space-y-2">
              <li><Link to="/faq" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">FAQs</Link></li>
              <li><Link to="/contact" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Contact</Link></li>
              <li><Link to="/intake" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Join the Hive</Link></li>
              <li><Link to="/hive/login" className="text-zinc-500 hover:text-[#D4AF37] text-sm transition-colors">Carrier Portal</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-800 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6">
            <Link to="/privacy-policy" className="text-zinc-500 hover:text-[#D4AF37] text-xs uppercase transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-zinc-500 hover:text-[#D4AF37] text-xs uppercase transition-colors">Terms of Service</Link>
            <Link to="/service-approval-policy" className="text-zinc-500 hover:text-[#D4AF37] text-xs uppercase transition-colors">Service Policy</Link>
            <Link to="/refund-policy" className="text-zinc-500 hover:text-[#D4AF37] text-xs uppercase transition-colors">Refund Policy</Link>
            <Link to="/subscription-cancellation-policy" className="text-zinc-500 hover:text-[#D4AF37] text-xs uppercase transition-colors">Cancellation</Link>
          </div>
          <p className="text-zinc-600 text-xs">© {year} Queen B Logistics. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
